import React from 'react';
import { Calculator, Shield } from 'lucide-react';

const Finance = ({ setActiveSection }) => {
  return (
    <section className="py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-gray-900 mb-4">A.G.O Finance</h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Choose the financial service that fits your needs. Our team will guide you through every step.
          </p>
        </div>

        {/* Two Main Service Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <div 
            onClick={() => setActiveSection('policy')} 
            className="bg-white p-10 rounded-2xl shadow-lg hover:shadow-2xl transition-all cursor-pointer border-2 border-transparent hover:border-emerald-500"
          >
            <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-6">
              <Shield className="text-emerald-600" size={32} />
            </div>
            <h3 className="text-gray-900 mb-3">Policy/Insurance</h3>
            <p className="text-gray-600 mb-4">
              Protect what matters most with comprehensive insurance coverage
            </p>
            <ul className="space-y-2 text-gray-700 mb-6">
              <li>✓ Life Insurance</li>
              <li>✓ Health Insurance</li>
              <li>✓ Vehicle Insurance</li>
              <li>✓ Home Insurance</li>
            </ul>
            <p className="text-emerald-600 text-sm">Get your quote →</p>
          </div>

          <div 
            onClick={() => setActiveSection('investment')} 
            className="bg-white p-10 rounded-2xl shadow-lg hover:shadow-2xl transition-all cursor-pointer border-2 border-transparent hover:border-emerald-500"
          >
            <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-6">
              <Calculator className="text-emerald-600" size={32} />
            </div>
            <h3 className="text-gray-900 mb-3">Investment</h3>
            <p className="text-gray-600 mb-4">
              Build wealth with smart investment strategies
            </p>
            <ul className="space-y-2 text-gray-700 mb-6">
              <li>✓ Mutual Funds</li>
              <li>✓ Fixed Deposits</li>
              <li>✓ Stock Market</li>
              <li>✓ Portfolio Management</li>
            </ul>
            <p className="text-emerald-600 text-sm">Start investing →</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Finance;